// makes deep copy of javascript objects
export function deepCopy<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    const arrCopy = [] as any[];
    obj.forEach((_, i) => {
      arrCopy[i] = deepCopy(obj[i]);
    });
    return arrCopy as unknown as T;
  }

  const objCopy = {} as { [key: string]: any };
  Object.keys(obj).forEach(key => {
    objCopy[key] = deepCopy((obj as { [key: string]: any })[key]);
  });

  return objCopy as T;
}
